module.exports = __webpack_public_path__ + "img/11.309cadd8.jpeg";